<template>
  <Wrapper>
    <div class="container-fluid pb-0">
      <div class="row">
        <div class="col-md-8 mx-auto text-center  pt-4 pb-5">
          <h1>
            <img
              alt="404"
              src="@/assets/theme/img/404.png"
              class="img-fluid"
            >
          </h1>
          <h1>Sorry! Page not found.</h1>
          <p class="land">
            Unfortunately the page you are looking for has been moved or deleted.
          </p>
          <div class="mt-5">
            <RouterLink
              class="btn btn-outline-primary"
              to="/"
            >
              <i class="mdi mdi-home" /> GO TO HOME PAGE
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
</template>

<script>
export default {};
</script>
